import React, { ComponentProps } from "react"

import * as styles from "./list-item.styled"

type ListItemProps = ComponentProps<"div"> & {
  title: string
  subtitle?: string
  RightIcon?: React.ReactNode
  rightText?: string
}

export const ListItem = ({ title, subtitle, RightIcon, rightText, ...rest }: ListItemProps) => {
  return (
    <div className={styles.container} {...rest}>
      <div className={styles.textContainer}>
        <p className={styles.title}>{title}</p>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
      {RightIcon ? RightIcon : null}
      {rightText ? <p className={styles.subtitle}>{rightText}</p> : null}
    </div>
  )
}
